/** Translation VO class */
export class WizTranslationObj {
  /** Translation key */
  public key: string;
  /** Translated text */
  public value: string;

  /**
   * Constructor
   * @param pKey Translation key
   * @param pValue Translated text
   */
  constructor(pKey: string, pValue: string) {
    this.key = pKey;
    this.value = pValue;
  }
}

/** Translation configuration class */
export class WizTranslationConfigurationObj {

  /**
   * Separator between key and translation.
   * Not applied if null, empty or undefined
   * Default value: '|'
   */
  public separator: string;

  /**
   * Comment character to bypass comment lines.
   * Not applied if undefined
   * Default value: '#'
   */
  public commentChar: string;

  /**
   * Translation file base path.
   * Not applied if null, empty or undefined
   * Default value: 'assets/locales/'
   */
  // public filePath: string;

  /**
   * Translation file name.
   * Not applied if null, empty or undefined
   * Default value: 'resources.txt'
   */
  // public fileName: string;

  /**
   * Default locale, always loaded.
   * Not applied if null, empty or undefined
   * Default value: 'en'
   */
  public defaultLocale: string;

  /**
   * Character before parameter index inside a translation key
   * Not applied if null, empty or undefined
   * Default value: '{'
   */
  // public translationVarStart: string;

  /**
   * Character after parameter index inside a translation key
   * Not applied if null, empty or undefined
   * Default value: '}'
   */
  // public translationVarEnd: string;

  /**
   * La version des resources à charger. Cela permet de s'assurer de charger la bonne version des resources et pas une version en cache.
   */
  // public resourceVersion: string;
}
